import { css } from "@emotion/css";

export const colors = {
  widget: "#1A3D74",
  hint: "#b4b3b3",
};

const inputStyle = css`
  input {
    width: 100%;
    font-size: 16px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    padding: 8px 10px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #A6B4BF;
    color: inherit;
    display: block;
    outline: none;

    &::placeholder {
      color: #ffffffb2;
    }
  }
`;

export const labelStyle = css`
  label {
    color:#F2E680;
    font-size: 18px;
    font-family: "Roboto", sans-serif;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 3px;
    display: block;
  }
`;

export const inputGroupStyled = css`
  position: relative;
  color: #003399;
  transition: all ease-out 200ms;

  &.required {
    input {
      border: 1px solid red;
    }
  }

  &.disabled {
    color: rgba(0, 0, 0, 0.4);
  }

  ${labelStyle}
  ${inputStyle}

  .error {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0;
    font-size: 12px;
    line-height: 10px;
    padding: 5px;
    color: #fb3640;
    white-space: nowrap;
  }
`;

export const groupSuggestionStyled = css`
  position: relative;

  ${inputGroupStyled}
  .suggestions {
    position: absolute;
    display: block;
    background-color: #fff;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.26s ease;
    z-index: 1000 !important;
    border-top: 1px solid ${colors.widget};
    font-size: 14px;
    color: ${colors.hint};

    .option {
      padding: 8px;
      color: ${colors.hint};
      font-size: 14px;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      &.active {
        background-color: #F2E680;
      }
    }
  }

  .coincidence {
    color: #000;
  }

  .open {
    transform: scaleY(1);
  }

  .error {
    margin: 0;
    font-size: 12px;
    line-height: 10px;
    color: #fb3640;
    position: absolute;
    padding-left: 5px;
    top: 30px;
  }
`;
